import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PhotoIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="photo" ref={ref} {...props}>
      <path d="M19.09,21.86H4.92a2.75,2.75,0,0,1-2.75-2.75V4.94A2.75,2.75,0,0,1,4.92,2.19H19.09a2.76,2.76,0,0,1,2.75,2.75V19.11A2.75,2.75,0,0,1,19.09,21.86ZM4.92,3.69A1.25,1.25,0,0,0,3.67,4.94V19.11a1.25,1.25,0,0,0,1.25,1.25H19.09a1.26,1.26,0,0,0,1.25-1.25V4.94a1.26,1.26,0,0,0-1.25-1.25ZM9,7.63a1.4,1.4,0,1,0,0,2.79A1.4,1.4,0,0,0,9,7.63ZM6.49,18.05H17.21c.6,0,.79,0,.79-.33v-4.4a18.11,18.11,0,0,0-1.78-1.92,1.27,1.27,0,0,0-1.68-.11c-.56.38-2,1.65-2.51,2.07a1.23,1.23,0,0,1-1.56,0c-.5-.31-.89-.54-1.51,0S6,16.1,6,16.1v1.42C6,17.79,6,18.05,6.49,18.05Z" />
    </Icon>
  ),
) as IconWithRender;

PhotoIcon.displayName = 'PhotoIcon';
PhotoIcon.renderIcon = (props) => <PhotoIcon {...props} />;
export default PhotoIcon;
